export const createGitHubUrl = (username?: string) =>
  username ? `https://www.github.com/${username}` : ''

export const getGitHubUser = (url: string | null) =>
  url ? url.substring(url.lastIndexOf('/') + 1) : ''
